import useFacility from "../../../../utils/hooks/useFacility";
import { Ticket } from "../../../models/Ticket";

export default function useOpenToSelect() {
  const facilityIds = useFacility();

  const addPossibilityToJoin = (ticket: Ticket): boolean => {
    // Wpisujemy id asortymentu typu open aby umożliwić zapis na zajecia. 

    if (facilityIds === "1212") {
      if (ticket.assortIds === "0,24" ||
        ticket.assortIds === "0,93" ||
        ticket.assortIds === "0,147" ||
        ticket.assortIds === "0,240" || 
        ticket.assortIds === "0,412" || 
        ticket.assortIds === "0,375" ||
        ticket.assortIds === "0,424" || 
        ticket.assortIds === "0,422"
      )
        return true
    }
    return false

  };

  return {
    addPossibilityToJoin,

  };
}
